import AclName from '../acl/AclName.js';
import model from '../models-v2/crm/subscription-order';
import routeName from './routeName';

export default [
  {
    path: '/subscription',
    name: routeName.subscription,
    components: {
      default: () => import('../views/pages/subscriptions/order-builder.vue'),
    },
    meta: {
      acl: AclName.CrmPageSubscriptionPanel,
      breadcrumb: [
        { title: 'Subskrypcja', url: '/subscription' },
      ],
    },
  },
  {
    path: '/crm-subscription-orders',
    name: 'crm-subscription-orders',
    components: {
      default: () => import('../pages/data-grid.vue'),
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
    meta: {
      breadcrumb: [
        { title: 'Zamówienia abonamentów', url: '/crm-subscription-orders' },
      ],
    },
  },
  {
    path: '/order-complete/:id',
    name: 'order-complete',
    components: {
      default: () => import('../views/pages/subscriptions/order-complete.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Zamówienia abonamentów', url: '/crm-subscription-orders' },
        { title: 'Zamówienie', url: '' },
      ],
    },
  },
];
